import styled from 'styled-components';
import { color, spacing } from 'theme';

export const Root = styled.div`
  background: ${color('indigo_700')};
  padding: ${spacing('xl4')} 0;
  color: #fff;
`;

export const Intro = styled.div`
  text-align: center;
  max-width: 55rem;
  margin: auto;

  h3 {
    margin-top: 1.5rem;
  }

  p {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }

  span[mode='light'] {
    background: #fff;
  }
`;
